'use client';

import { Apis, depaginate } from '@data-access';
import { APIHelper } from '@helpers';
import { makeObservable, observable, action } from 'mobx';

type DBValues = Record<string, string>;
type Value = { frontendId: string; text: string };

export class NotionStore {
  values: DBValues = null;

  constructor() {
    makeObservable(this, { values: observable, setValues: action.bound });
  }

  async setValues() {
    // Already loaded — setValues is called from both _app mount and login.
    if (this.values !== null) {
      return;
    }

    let apis: Apis;

    try {
      const config = await APIHelper.createApiConfiguration();
      apis = APIHelper.createApisFromConfig(config);
    } catch (error) {
      console.log(error);
    }

    try {
      // pageSize is the backend max, so this is one request instead of ~8 serial ones.
      const infoboxes = await depaginate(page => apis?.api.apiInfoboxList({ page, pageSize: 100 }));

      const values = {};
      infoboxes?.forEach((value: Value) => {
        values[value.frontendId] = value.text;
      });
      this.values = values;
    } catch (error) {
      console.log(error);
    }
  }
}

export const notionStore = new NotionStore();
